import { render, staticRenderFns } from "./ManageParentCategories.vue?vue&type=template&id=59a13f36&"
import script from "./ManageParentCategories.vue?vue&type=script&lang=js&"
export * from "./ManageParentCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports